import { computed } from "vue";
import { useAppsStore } from "@/pinia/appsStore";
import { useCustomFields } from "@/utils/composables/useCustomFields";
import {
  customOrUsageFilters,
  getCustomFiltersData,
  getDisplayFilters,
  getUsageFilterData,
} from "@/utils/segmentsHelpers";

export const useSegmentFilters = () => {
  const appsStore = useAppsStore();
  const { appCustomFields } = useCustomFields();

  const customFilters = computed(() => getCustomFiltersData(appCustomFields.value));

  const buildFilters = segment => ({
    usage: customOrUsageFilters(getUsageFilterData(appCustomFields.value), segment.custom_filter),
    user: segment.filter?.user,
    device: segment.filter?.device,
    custom: customOrUsageFilters(customFilters.value, segment.custom_filter),
    customFilters: customFilters.value,
    location: segment.filter?.location,
    locationConfigs: segment.filter?.location_configs,
    promoInteraction: segment.custom_filter?.promo_interaction,
    userBucket: segment.filter?.user_bucket,
    userId: segment.filter?.user_id,
  });

  const getDisplayFiltersForSegment = segment =>
    getDisplayFilters(buildFilters(segment), appsStore.app?.custom_devices ?? []);

  return { customFilters, buildFilters, getDisplayFiltersForSegment };
};
